// @flow

// Constants

// Action Types
import {
  RECEIVE_TOKEN,
} from 'fc-auth/src/constants'

// Sagas
import Storage from 'fc-storage'

// Effect Managers
import { take, call } from 'redux-saga/effects'

// Exports
export default function *watchReceiveToken (): Generator<*, void, *> {
  const { payload }: { payload: { token: string } } = yield take(RECEIVE_TOKEN)
  if (payload.token) {
    try {
      yield call([Storage, Storage.setItem], 'token', payload.token)
    } catch (error) {

    }
  }
}
